import React from 'react';

const TrustElements = () => {
  return (
    <div className="bg-white border-y border-slate-100 py-8">
      <div className="container-custom">
        <p className="text-center text-sm font-medium text-slate-400 uppercase tracking-wider mb-6">
          Bekannt für zuverlässige Vermittlung in
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-300">
          <span className="text-xl font-bold text-slate-800">Hamburg</span>
          <span className="text-xl font-bold text-slate-800">Schleswig-Holstein</span>
          <span className="text-xl font-bold text-slate-800">Niedersachsen</span>
          <span className="text-xl font-bold text-slate-800">Bremen</span>
        </div>
      </div>
    </div>
  );
};

export default TrustElements;